/**
 * Cart drawer helpers (event delegation — survives section re-renders):
 * 1) Plus/minus quantity stepper
 * 2) Remove AJAX when click lands on SVG inside <a>
 * 3) 2 Pack → 3 Pack upgrade upsell (+ ADD) in theme cart drawer
 * 4) Spend-unlock free gifts (variant select + add $0 gift)
 * 5) Monster Cart only: [data-pack-upgrade-open] closes cart + opens Pack Builder
 */
(function () {
  var busy = false;

  function closeMonsterCart() {
    try {
      var monster = document.getElementById('monster-cart-wrapper');
      if (monster) {
        monster.classList.remove('mu_open');
        monster.classList.add('mu_closed');
        var overlay = document.querySelector('[class*="monster_upsell_overlay"]');
        if (overlay) overlay.style.display = 'none';
      }
    } catch (e) {}
  }

  /** Monster Cart upgrade CTA only — not used by theme cart drawer product grid */
  function openPackUpgradeFromMonster(link) {
    var href = link.getAttribute('href') || '';
    closeMonsterCart();
    if (typeof window.BandifyOpenPackTier === 'function' && document.querySelector('[data-pack-builder]')) {
      try {
        window.BandifyOpenPackTier('3');
        return;
      } catch (e) {}
    }
    if (href) window.location.href = href;
  }

  function rootPath() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function inCartDrawer(el) {
    return !!(el && el.closest && el.closest('cart-drawer, #cart-drawer'));
  }

  function prepareCartSections() {
    // Start empty — invalid section ids break cart/add.js and block drawer refresh.
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sections }
      })
    );
    return sections;
  }

  function refreshCartDrawer(cartContent, responseJson) {
    var items =
      responseJson && responseJson.items
        ? responseJson.items
        : responseJson
          ? [responseJson]
          : [];
    if (cartContent && responseJson && responseJson.sections) {
      cartContent.sections = responseJson.sections;
    }
    document.documentElement.dispatchEvent(
      new CustomEvent('variant:add', {
        bubbles: true,
        detail: { items: items, cart: cartContent || {} }
      })
    );
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:add', cart: cartContent || {} }
      })
    );
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    var drawer = document.querySelector('cart-drawer#cart-drawer, cart-drawer, #cart-drawer');
    if (drawer) {
      if (typeof drawer.show === 'function') drawer.show();
      else if ('open' in drawer) drawer.open = true;
      else drawer.setAttribute('open', '');
    }
  }

  function changeQty(input, step) {
    if (!input || busy) return;
    var min = parseInt(input.getAttribute('min') || '0', 10);
    if (isNaN(min)) min = 0;
    var maxAttr = input.getAttribute('max');
    var max = maxAttr ? parseInt(maxAttr, 10) : Number.MAX_SAFE_INTEGER;
    if (isNaN(max)) max = Number.MAX_SAFE_INTEGER;

    var current = parseInt(input.value || '1', 10);
    if (isNaN(current)) current = 1;

    var next = current + step;
    if (next < min) next = min;
    if (next > max) next = max;
    if (next === current) return;

    var lineKey = input.getAttribute('data-line-key');
    var qtyRoot = input.closest('line-item-quantity');

    if (lineKey && qtyRoot && typeof qtyRoot._changeLineItemQuantity === 'function') {
      busy = true;
      Promise.resolve(qtyRoot._changeLineItemQuantity(lineKey, next))
        .catch(function () {})
        .then(function () {
          busy = false;
        });
      return;
    }

    input.value = String(next);
    try {
      if ('quantity' in input) input.quantity = next;
    } catch (e) {}
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function getUpgradeVariantId(card, btn) {
    var select = card.querySelector('select[data-upgrade-variant]');
    if (select && select.value) return select.value;
    var hidden = card.querySelector('input[data-upgrade-variant]');
    if (hidden && hidden.value) return hidden.value;
    return btn.getAttribute('data-variant-id');
  }

  function getGiftVariantId(card, btn) {
    var select = card.querySelector('select[data-gift-variant]');
    if (select && select.value) return select.value;
    var hidden = card.querySelector('input[data-gift-variant]');
    if (hidden && hidden.value) return hidden.value;
    return btn.getAttribute('data-variant-id');
  }

  function addGiftItem(btn) {
    if (busy || btn.disabled) return;
    var card = btn.closest('[data-gift-card]');
    if (!card) return;
    if (card.getAttribute('data-gift-unlocked') !== 'true') return;

    var variantId = getGiftVariantId(card, btn);
    var tier = btn.getAttribute('data-gift-tier') || card.getAttribute('data-gift-tier') || '1';
    if (!variantId) return;

    busy = true;
    btn.disabled = true;
    var prev = btn.textContent;
    btn.textContent = 'ADDING…';

    var sections = prepareCartSections();
    fetch(rootPath() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1,
            properties: {
              _bandify_cart_gift: String(tier),
              _bandify_free_gift: 'true'
            }
          }
        ],
        sections: sections
      })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          alert(
            (result.data && (result.data.description || result.data.message)) ||
              'Could not add free gift. Please try again.'
          );
          btn.disabled = false;
          btn.textContent = prev;
          busy = false;
          return null;
        }
        return fetch(rootPath() + 'cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            refreshCartDrawer(cart, result.data);
          });
      })
      .catch(function () {
        alert('Could not add free gift. Please try again.');
        btn.disabled = false;
        btn.textContent = prev;
      })
      .finally(function () {
        busy = false;
      });
  }

  function addUpgradeItem(btn) {
    if (busy || btn.disabled) return;
    var card = btn.closest('[data-upgrade-card]');
    if (!card) return;
    var variantId = getUpgradeVariantId(card, btn);
    if (!variantId) return;

    busy = true;
    btn.disabled = true;
    var prev = btn.textContent;
    btn.textContent = 'ADDING…';

    var sections = prepareCartSections();
    fetch(rootPath() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1,
            properties: {
              _bandify_pack_upgrade: '3',
              _bandify_slot_type: 'paid',
              _bandify_discount_percent: '35'
            }
          }
        ],
        sections: sections
      })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          alert(
            (result.data && (result.data.description || result.data.message)) ||
              'Could not add item. Please try again.'
          );
          btn.disabled = false;
          btn.textContent = prev;
          busy = false;
          return null;
        }
        return fetch(rootPath() + 'cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            refreshCartDrawer(cart, result.data);
          });
      })
      .catch(function () {
        alert('Could not add item. Please try again.');
        btn.disabled = false;
        btn.textContent = prev;
      })
      .finally(function () {
        busy = false;
      });
  }

  function onClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    // Monster Cart only — open Pack Builder (3 Pack)
    var upgradeOpen = target.closest('[data-pack-upgrade-open]');
    if (upgradeOpen && !inCartDrawer(upgradeOpen)) {
      event.preventDefault();
      event.stopPropagation();
      openPackUpgradeFromMonster(upgradeOpen);
      return;
    }

    var giftBtn = target.closest('[data-gift-add]');
    if (giftBtn && inCartDrawer(giftBtn)) {
      event.preventDefault();
      event.stopPropagation();
      addGiftItem(giftBtn);
      return;
    }

    var upgradeBtn = target.closest('[data-pack-upgrade-add]');
    if (upgradeBtn && inCartDrawer(upgradeBtn)) {
      event.preventDefault();
      event.stopPropagation();
      addUpgradeItem(upgradeBtn);
      return;
    }

    var btn = target.closest('[data-qty-step]');
    if (btn && inCartDrawer(btn)) {
      event.preventDefault();
      event.stopPropagation();
      var step = parseInt(btn.getAttribute('data-qty-step') || '0', 10);
      if (!step) return;
      var stepper = btn.closest('.line-item__qty-stepper') || btn.parentElement;
      var input =
        (stepper && stepper.querySelector('input.quantity-input, input[data-line-key]')) ||
        (btn.closest('line-item-quantity') &&
          btn.closest('line-item-quantity').querySelector('input.quantity-input, input[data-line-key]'));
      changeQty(input, step);
      return;
    }

    var link = target.closest('a.line-item__remove, line-item-quantity a.link');
    if (!link || !inCartDrawer(link)) return;
    if (!link.href || link.href.indexOf('/cart/change') === -1) return;
    if (target === link) return;

    event.preventDefault();
    event.stopPropagation();

    var qtyEl = link.closest('line-item-quantity');
    if (!qtyEl || typeof qtyEl._changeLineItemQuantity !== 'function') {
      window.location.href = link.href;
      return;
    }

    try {
      var url = new URL(link.href, window.location.origin);
      var id = url.searchParams.get('id');
      var quantity = parseInt(url.searchParams.get('quantity') || '0', 10);
      busy = true;
      Promise.resolve(qtyEl._changeLineItemQuantity(id, quantity))
        .catch(function () {
          window.location.href = link.href;
        })
        .then(function () {
          busy = false;
        });
    } catch (err) {
      busy = false;
      window.location.href = link.href;
    }
  }

  function onChange(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var giftSelect = target.closest('select[data-gift-variant]');
    if (giftSelect && inCartDrawer(giftSelect)) {
      var giftCard = giftSelect.closest('[data-gift-card]');
      if (giftCard) {
        var giftAdd = giftCard.querySelector('[data-gift-add]');
        if (giftAdd) giftAdd.setAttribute('data-variant-id', giftSelect.value);
      }
      return;
    }

    var select = target.closest('select[data-upgrade-variant]');
    if (!select || !inCartDrawer(select)) return;
    var card = select.closest('[data-upgrade-card]');
    if (!card) return;
    var addBtn = card.querySelector('[data-pack-upgrade-add]');
    if (addBtn) addBtn.setAttribute('data-variant-id', select.value);
  }

  /* Monster-style cart expiry countdown (session) */
  var TIMER_KEY = 'bandify_cart_expires_at';
  var timerInterval = null;

  function pad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function formatRemain(ms) {
    if (ms < 0) ms = 0;
    var totalSec = Math.floor(ms / 1000);
    var m = Math.floor(totalSec / 60);
    var s = totalSec % 60;
    return pad2(m) + ':' + pad2(s);
  }

  function ensureExpiry(minutes) {
    var mins = Number(minutes) || 10;
    var now = Date.now();
    var existing = 0;
    try {
      existing = parseInt(sessionStorage.getItem(TIMER_KEY) || '0', 10) || 0;
    } catch (e) {}
    if (!existing || existing <= now) {
      existing = now + mins * 60 * 1000;
      try {
        sessionStorage.setItem(TIMER_KEY, String(existing));
      } catch (e2) {}
    }
    return existing;
  }

  function tickCartTimer() {
    var el = document.querySelector('[data-cart-timer]');
    if (!el) return;
    var display = el.querySelector('[data-cart-timer-display]');
    if (!display) return;
    var minutes = el.getAttribute('data-timer-minutes') || '10';
    var expiresAt = ensureExpiry(minutes);
    var remain = expiresAt - Date.now();
    display.textContent = formatRemain(remain);
    if (remain <= 0) {
      try {
        sessionStorage.removeItem(TIMER_KEY);
      } catch (e) {}
      ensureExpiry(minutes);
    }
  }

  function startCartTimer() {
    tickCartTimer();
    if (timerInterval) clearInterval(timerInterval);
    timerInterval = setInterval(tickCartTimer, 1000);
  }

  document.addEventListener('click', onClick, true);
  document.addEventListener('change', onChange, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startCartTimer);
  } else {
    startCartTimer();
  }
  document.addEventListener('cart:change', function () {
    setTimeout(startCartTimer, 50);
  });
  document.addEventListener('cart:refresh', function () {
    setTimeout(startCartTimer, 50);
  });

  // Multi-country gift/shipping thresholds (CVR-safe):
  // Convert AUD thresholds ONLY when Shopify Markets has actually converted
  // product/cart money (probe product price differs from shop price).
  // Never use currencies.js / guessed FX — that inflated "Rs.11,000 to unlock"
  // while cart was still AUD-scale and blocked free gifts → CVR drop.
  function marketsFxRate(root) {
    if (!root) return 1;
    var shopCurrency = root.getAttribute('data-shop-currency') || '';
    var cartCurrency =
      root.getAttribute('data-cart-currency') ||
      (window.Shopify && Shopify.currency && Shopify.currency.active) ||
      '';
    if (!shopCurrency || !cartCurrency || shopCurrency === cartCurrency) return 1;

    try {
      if (shopCurrency === cartCurrency) {
        var probeNow = parseInt(root.getAttribute('data-probe-presentment-cents') || '0', 10);
        if (probeNow > 0) sessionStorage.setItem('bfy_probe_shop_cents', String(probeNow));
      } else {
        var cached = parseInt(sessionStorage.getItem('bfy_probe_shop_cents') || '0', 10);
        if (cached > 0) root.setAttribute('data-probe-shop-cents', String(cached));
      }
    } catch (eCache) {}

    var liquidRate = parseFloat(root.getAttribute('data-fx-rate') || '0');
    var probePres = parseFloat(root.getAttribute('data-probe-presentment-cents') || '0');
    var probeShop = parseFloat(root.getAttribute('data-probe-shop-cents') || '0');
    var rate = 1;
    if (liquidRate > 0 && Math.abs(liquidRate - 1) > 0.001) rate = liquidRate;
    else if (probeShop > 0 && probePres > 0 && Math.abs(probePres - probeShop) / probeShop > 0.02) {
      rate = probePres / probeShop;
    }
    // Sanity: ignore absurd rates that would break unlocks
    if (!(rate > 0.05 && rate < 500)) rate = 1;
    return rate;
  }

  function formatMoneyCents(cents, currencyIso, format) {
    cents = Math.max(0, Math.round(Number(cents) || 0));
    var iso =
      currencyIso ||
      (window.Shopify && Shopify.currency && Shopify.currency.active) ||
      '';
    if (iso) {
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: iso,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(cents / 100);
      } catch (e) {}
    }
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      try {
        return Shopify.formatMoney(cents, format || undefined);
      } catch (e2) {}
    }
    var value = (cents / 100).toFixed(2);
    if (format) {
      return String(format)
        .replace(/\{\{\s*amount\s*\}\}/, value)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
    }
    return (iso ? iso + ' ' : '$') + value;
  }

  function setHidden(el, hide) {
    if (!el) return;
    if (hide) el.setAttribute('hidden', '');
    else el.removeAttribute('hidden');
  }

  function applySpendThresholds(root, rate) {
    if (!root) return;
    // Always prefer live selected currency over SSR attribute (can lag after switch)
    var cartCurrency =
      (window.Shopify && Shopify.currency && Shopify.currency.active) ||
      root.getAttribute('data-cart-currency') ||
      root.getAttribute('data-shop-currency') ||
      '';
    if (cartCurrency) root.setAttribute('data-cart-currency', cartCurrency);
    var spend = parseInt(root.getAttribute('data-cart-spend') || '0', 10) || 0;
    var g1Shop = parseInt(root.getAttribute('data-gift1-shop-cents') || '0', 10) || 0;
    var g2Shop = parseInt(root.getAttribute('data-gift2-shop-cents') || '0', 10) || 0;
    var shipShop = parseInt(root.getAttribute('data-ship-shop-cents') || '0', 10) || 0;
    var g1Active = root.getAttribute('data-gift1-active') === 'true';
    var g2Active = root.getAttribute('data-gift2-active') === 'true';
    var g1InCart = root.getAttribute('data-gift1-in-cart') === 'true';
    var g2InCart = root.getAttribute('data-gift2-in-cart') === 'true';
    var g1Label = root.getAttribute('data-gift1-label') || 'Screen Protector';
    var g2Label = root.getAttribute('data-gift2-label') || 'iPhone Case';
    var moneyFormat = root.getAttribute('data-money-format') || '';

    // Same rate for unlock math AND display — always matches cart.total_price units
    var fx = rate && rate > 0 ? rate : 1;
    var g1 = Math.round(g1Shop * fx);
    var g2 = Math.round(g2Shop * fx);
    var ship = Math.round(shipShop * fx);
    var u1 = g1Active && spend >= g1;
    var u2 = g2Active && spend >= g2;

    var maxT = 0;
    if (g1Active) maxT = Math.max(maxT, g1);
    if (g2Active) maxT = Math.max(maxT, g2);
    var pct = maxT > 0 ? Math.min(100, Math.max(0, (spend * 100) / maxT)) : 0;
    var fill = root.querySelector('[data-bfy-gifts-fill]');
    if (fill) fill.style.width = pct + '%';

    var m1 = root.querySelector('[data-bfy-gift-marker="1"]');
    var m2 = root.querySelector('[data-bfy-gift-marker="2"]');
    if (m1 && maxT > 0) {
      m1.style.left = Math.min(100, (g1 * 100) / maxT) + '%';
      m1.classList.toggle('is-on', u1);
    }
    if (m2 && maxT > 0) {
      m2.style.left = Math.min(100, (g2 * 100) / maxT) + '%';
      m2.classList.toggle('is-on', u2);
    }
    var l1 = root.querySelector('[data-bfy-gift-label="1"]');
    var l2 = root.querySelector('[data-bfy-gift-label="2"]');
    if (l1) l1.classList.toggle('is-on', u1);
    if (l2) l2.classList.toggle('is-on', u2);

    var nextRemain = 0;
    var nextLabel = '';
    if (g1Active && !u1 && g2Active && !u2) {
      var r1 = Math.max(0, g1 - spend);
      var r2 = Math.max(0, g2 - spend);
      if (r1 <= r2) {
        nextRemain = r1;
        nextLabel = g1Label;
      } else {
        nextRemain = r2;
        nextLabel = g2Label;
      }
    } else if (g1Active && !u1) {
      nextRemain = Math.max(0, g1 - spend);
      nextLabel = g1Label;
    } else if (g2Active && !u2) {
      nextRemain = Math.max(0, g2 - spend);
      nextLabel = g2Label;
    }

    var statusAway = root.querySelector('[data-bfy-gifts-status]');
    var statusOk = root.querySelector('[data-bfy-gifts-unlocked]');
    if (nextLabel && nextRemain > 0) {
      setHidden(statusAway, false);
      setHidden(statusOk, true);
      var remEl = root.querySelector('[data-bfy-gifts-remaining]');
      var labEl = root.querySelector('[data-bfy-gifts-next-label]');
      if (remEl) remEl.textContent = formatMoneyCents(nextRemain, cartCurrency, moneyFormat);
      if (labEl) labEl.textContent = nextLabel;
    } else if (u1 || u2) {
      setHidden(statusAway, true);
      setHidden(statusOk, false);
      var copy = root.querySelector('[data-bfy-gifts-unlocked-copy]');
      if (copy) {
        if (u1 && u2) copy.textContent = "You've unlocked your free gifts";
        else if (u1) copy.textContent = "You've unlocked a FREE " + g1Label;
        else copy.textContent = "You've unlocked a FREE " + g2Label;
      }
    } else {
      setHidden(statusAway, true);
      setHidden(statusOk, true);
    }

    function syncGiftCard(tier, unlocked, thresholdCents) {
      var card = root.querySelector('[data-gift-card][data-gift-tier="' + tier + '"]');
      if (!card) return;
      card.classList.toggle('is-unlocked', unlocked);
      card.classList.toggle('is-locked', !unlocked);
      card.setAttribute('data-gift-unlocked', unlocked ? 'true' : 'false');
      setHidden(card.querySelector('[data-gift-kicker-unlocked]'), !unlocked);
      setHidden(card.querySelector('[data-gift-kicker-locked]'), unlocked);
      setHidden(card.querySelector('[data-gift-unlock-panel]'), !unlocked);
      setHidden(card.querySelector('[data-gift-locked-note]'), unlocked);
      var rem = card.querySelector('[data-bfy-tier-remaining="' + tier + '"]');
      if (rem) rem.textContent = formatMoneyCents(Math.max(0, thresholdCents - spend), cartCurrency, moneyFormat);
      var unlocks = card.querySelector('[data-bfy-tier-unlocks="' + tier + '"]');
      if (unlocks) unlocks.textContent = formatMoneyCents(thresholdCents, cartCurrency, moneyFormat);
    }
    if (g1Active && !g1InCart) syncGiftCard(1, u1, g1);
    if (g2Active && !g2InCart) syncGiftCard(2, u2, g2);

    if (root.getAttribute('data-ship-enabled') === 'true') {
      var shipMsg = root.querySelector('[data-bfy-ship-msg]');
      if (shipMsg) {
        var shipOk = spend >= ship;
        if (shipOk) {
          shipMsg.classList.add('is-unlocked');
          shipMsg.textContent = root.getAttribute('data-ship-unlocked-text') || "You've unlocked Free Shipping!";
        } else {
          shipMsg.classList.remove('is-unlocked');
          shipMsg.innerHTML =
            'You are <strong data-bfy-ship-remaining>' +
            formatMoneyCents(Math.max(0, ship - spend), cartCurrency, moneyFormat) +
            '</strong> away from <strong>Free Shipping</strong>';
        }
      }
    }
  }

  function syncSpendThresholds() {
    var root = document.querySelector('[data-bfy-spend-thresholds]');
    if (!root) return;
    applySpendThresholds(root, marketsFxRate(root));
  }

  // Flag cart page for CSS-only Hextom "SAVE %" badge hide.
  // Do NOT MutationObserver + walk body* — that froze the UI and blocked cart-drawer open.
  function syncCartFlags() {
    var onCart = /\/cart\/?$/i.test(window.location.pathname);
    var html = document.documentElement;
    if (onCart) html.classList.add('bandify-on-cart');
    else html.classList.remove('bandify-on-cart');

    var drawer = document.querySelector('cart-drawer, #cart-drawer');
    var open =
      !!drawer &&
      (drawer.hasAttribute('open') || drawer.open === true || drawer.classList.contains('is-open'));
    if (open) html.classList.add('bandify-cart-open');
    else html.classList.remove('bandify-cart-open');
  }

  function watchCartFlags() {
    syncCartFlags();
    syncSpendThresholds();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCartFlags);
  } else {
    watchCartFlags();
  }
  document.addEventListener('cart:change', watchCartFlags);
  document.addEventListener('cart:refresh', watchCartFlags);
  document.addEventListener('currency:change', watchCartFlags);
  // Re-run after Shopify currency.js settles
  setTimeout(syncSpendThresholds, 300);
  setTimeout(syncSpendThresholds, 1200);
  // Light toggle when drawer open attribute changes (no subtree / no class-loop)
  try {
    var drawerEl = document.querySelector('cart-drawer, #cart-drawer');
    if (drawerEl) {
      new MutationObserver(function () {
        syncCartFlags();
        syncSpendThresholds();
      }).observe(drawerEl, { attributes: true, attributeFilter: ['open', 'class'] });
    }
  } catch (eObs) {}
})();
